import styled from 'styled-components';
import { media } from '@minecraft.themes';
import { SummaryContainer, SummaryInfo } from '../SummaryStyles';

export const StyledSummaryContainer = styled(SummaryContainer)`
  flex-direction: column;
`;

export const SummaryTopContent = styled(SummaryContainer)`
  flex-direction: column;

  ${media.lg`
    flex-direction: row;
  `}
`;

export const SummaryBottomContent = styled.div`
  border: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  margin-top: 1rem;

  ${media.lg`
    flex-direction: row;
    padding: 1rem 0;
  `}
`;

export const SummaryBottomContentItem = styled.div`
  flex: 1;
  padding: 1rem 0;

  &:not(:last-child) {
    border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};

    ${media.lg`
      border-bottom: 0;
      border-right: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
    `}
  }

  ${media.lg`
    padding: 0 1rem;
  `}
`;

export const StyledSummaryInfo = styled(SummaryInfo)`
  margin-top: 2rem;
  margin-left: 0;

  ${media.lg`
    margin-top: 0;
    margin-left: 2rem;
  `}
`;
